import { Skeleton } from '@components/skeleton/Skeleton';
import { EMPTY_VALUE } from '@pages/settings/profile/utils';
import type { FC } from 'react';

interface InfoRowProps {
	label: string;
	value?: string;
	isLoading: boolean;
}

export const InfoRow: FC<InfoRowProps> = ({ label, value, isLoading }) => (
	<div className="flex flex-col gap-space-2">
		<dt className="text-sm-medium text-neutral-600">{label}</dt>
		<dd className="text-sm-bold">
			{isLoading ? <Skeleton className="h-[20px]" /> : value || EMPTY_VALUE}
		</dd>
	</div>
);
